module.exports = __webpack_public_path__ + "static/media/SF_bm_sentrert_logo_vestland_pos.4ada5619.pdf";